import React, { Component } from 'react';
import packageJson from '../../package.json';
import AuthService from '../services/api/auth';

export default class Version extends Component {
    state = {
        version: 0,
    };
    componentDidMount() {
        AuthService.getFormVersion().then(data => {
            this.setState(data);
        });
    }
    render() {
        return (
            <ul>
                <li>FRONTEND: {packageJson.version}</li>
                <li>BACKEND: {this.state.version}</li>
            </ul>
        );
    }
}
